export default {
  en: {
    type: { closed: 'Closed', open: 'Open', private: 'Private' },
  },
};
